var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    stroke: "none",
    d: "m12 15.597 6 4V8c0-.959-.001-1.578-.033-2.052-.031-.456-.085-.63-.12-.713a2 2 0 0 0-1.082-1.083c-.083-.034-.256-.087-.713-.118C15.58 4 14.96 4 14 4h-4c-.96 0-1.579.001-2.052.034-.456.03-.63.084-.713.118a2 2 0 0 0-1.083 1.083c-.034.083-.087.257-.119.713C6.001 6.422 6 7.04 6 8v11.596l6-4ZM6 22H4V8c0-1.864 0-2.795.304-3.53A4 4 0 0 1 6.47 2.305C7.204 2 8.136 2 10 2h4c1.864 0 2.796 0 3.53.305a4 4 0 0 1 2.165 2.165C20 5.205 20 6.136 20 8v14h-2l-6-4-6 4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.44daa6d24726afd1fda6a7b8d86087f7.svg";
export { ForwardRef as ReactComponent };